import { zod } from '@acme/core'
import { z } from 'zod'

import ApiService from '../api.service'

export type FuncoesAvaliacao = z.infer<typeof zod.FuncoesAvaliacaoSchema>

export const funcoesAvaliacao = new ApiService<FuncoesAvaliacao>(
    'avaliacao/funcao',
)
